import {
  ref,
} from "vue";

import AHttpAPI from "aloha-vue/src/compositionAPI/AHttpAPI";

import {
  forEach,
} from "lodash-es";


export default function MainAPI() {
  const loading = ref(false);
  const allIcons = ref([]);

  const {
    getHttp,
  } = AHttpAPI();

  const loadObjekticons = () => {
    loading.value = true;
    getHttp({
      url: "katalog/",
      urlParams: {
        key: "k_objekticons",
      },
      apiSaveId: "k_objekticons",
    }).then(
      response => {
        allIcons.value = response;
        forEach(allIcons.value, oic => {
          oic.labelExtra = {
            bez: oic.oic_kbez,
            title: oic.oic_icon.title,
          };
          oic.label = oic.oic_freitext ? "_LBL_GR_OBJEKTICON_VERGABE_ICON_MIT_FREITEXT_{{bez}}_{{title}}_" : "_LBL_GR_OBJEKTICON_VERGABE_ICON_OHNE_FREITEXT_{{bez}}_{{title}}_";
        });
      },
    ).finally(
      () => loading.value = false,
    );
  };

  return {
    allIcons,
    loading,
    loadObjekticons,
  };
}
